import { render, staticRenderFns } from "./seeMail.vue?vue&type=template&id=46330d3a&scoped=true"
import script from "./seeMail.vue?vue&type=script&lang=js"
export * from "./seeMail.vue?vue&type=script&lang=js"
import style0 from "./seeMail.vue?vue&type=style&index=0&id=46330d3a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46330d3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46330d3a')) {
      api.createRecord('46330d3a', component.options)
    } else {
      api.reload('46330d3a', component.options)
    }
    module.hot.accept("./seeMail.vue?vue&type=template&id=46330d3a&scoped=true", function () {
      api.rerender('46330d3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/claim/customerRecordManage/modelForm/seeMail.vue"
export default component.exports